<template>
  <div class="cigar-list">
    <UploadCustomize id="2" />
    <div class="table-search">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <div>
          <el-form-item label="配件类别：">
            <el-select
              v-model="form.boutiqueCategory"
              placeholder="请选择"
              @change="selectTag"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="配件名称：" class="fineName" prop="boutiqueName">
            <el-input
              type="text"
              placeholder="请输入名称"
              v-model="form.boutiqueName"
              @input="handleInputChange"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
          <el-button type="primary" @click="handleAdd">添加商品</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column label="排序" type="index" align="center"></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.boutiqueUrl" alt class="memberImg" />
          </template>
        </el-table-column>
        <el-table-column prop="boutiqueName" label="名称" align="center"></el-table-column>
        <el-table-column prop="boutiqueEnglishName" label="英文名" align="center"></el-table-column>
        <el-table-column prop="boutiqueCategory" label="配件类别" align="center"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.boutiqueState">上架</span>
            <span v-else>下架</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="130px">
          <template slot-scope="scope">
            <span
              class="upShelves"
              v-if="!scope.row.boutiqueState"
              @click="handleShelves(scope.row.id)"
            >上架</span>
            <span class="downShelves" v-else @click="handleShelves(scope.row.id)">下架</span>
            <span class="view" @click="handlePreview(scope.row)">预览</span>
            <el-popover
              popper-class="wechatCode"
              placement="top"
              width="60"
              trigger="click">
              <img :src="scope.row.boutiqueQrCode" alt class="wechatImg" />
              <span class="wechat" slot="reference">小程序码</span>
            </el-popover>
            <span class="del" @click="handleDel(scope.row.id)">删除</span>
            <span class="editor" @click="handleEditor(scope.row.id)">编辑</span>
            <span class="path" @click="openDialog(scope.row.boutiquePath)">路径配置</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <copyDialog :visible="visible" :configPath="path" @close="visible = false"/>
    <Preview
      :visible="previewVisible"
      :selectId="currentCellId"
      @close="handleClosePreview"
    />
  </div>
</template>
<script>
import {
  getBoutiqueList, exportBoutique, updateBoutiqueUpAndDown, deleteBoutique,
} from '@/api/goods';
import Preview from '@/components/h5/finesgoodsPage.vue';
import Pagination from '@/components/Pagination';
import copyDialog from '@/components/copyDialog';
import Excel from '@/mixins/export';
import preview from '@/mixins/mobile';
import UploadCustomize from '../components/UploadCustomize.vue';

export default {
  mixins: [Excel, preview],
  name: 'FinesGoodList',
  data() {
    return {
      visible: false,
      path: '',
      form: {
        boutiqueCategory: '',
        boutiqueName: '',
      },
      options: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '保湿箱',
          label: '保湿箱',
        },
        {
          value: '烟灰缸',
          label: '烟灰缸',
        },
        {
          value: '剪刀',
          label: '剪刀',
        },
        {
          value: '火机',
          label: '火机',
        },
        {
          value: '其他配件',
          label: '其他配件',
        },
      ],
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
    };
  },
  components: {
    Pagination,
    copyDialog,
    Preview,
    UploadCustomize,
  },
  created() {
    this.handleInputChange = this.$debounce(this.handleInputChange, 500, {
      leading: false,
      trailing: true,
    });
  },
  mounted() {
    this.getBoutiqueList();
  },
  methods: {
    getBoutiqueList() {
      this.loading = true;
      return getBoutiqueList({
        boutiqueName: this.form.boutiqueName,
        boutiqueCategory: this.form.boutiqueCategory,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          const { total, list } = res.data;
          if (list && Array.isArray(list)) {
            this.tableData = list;
            this.total = parseInt(total, 10);
            return this.tableData;
          }
        } else {
          this.$message.error(res.message);
        }
        return false;
      });
    },
    // 导出
    handleExport() {
      exportBoutique(this.form).then((res) => {
        this.exportExcel(res, '配件列表');
      });
    },
    // 精品类别
    selectTag() {
      this.getBoutiqueList();
    },
    // 输入查询
    handleInputChange() {
      this.currentPage = 1;
      this.getBoutiqueList();
    },
    // 上下架
    handleShelves(id) {
      updateBoutiqueUpAndDown(id).then((res) => {
        if (res.success) {
          this.getBoutiqueList();
          this.$message.success('操作成功');
        } else {
          this.$message.success(res.message);
        }
      });
    },
    // 获取页面路径
    openDialog(value) {
      this.path = value;
      this.visible = true;
    },
    // 分页
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getBoutiqueList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getBoutiqueList();
    },
    // 添加商品
    handleAdd() {
      this.$router.push({ name: 'FinesGoodAdd' });
    },
    // 删除
    handleDel(id) {
      deleteBoutique(id).then((res) => {
        if (res.success) {
          this.getBoutiqueList();
          this.$message.success('删除成功');
        } else {
          this.$message.success(res.message);
        }
      });
    },
    // 编辑
    handleEditor(id) {
      this.$router.push({
        name: 'FinesGoodEditor',
        query: {
          id,
        },
      });
    },
    // 预览
    handleView() {
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.demo-form-inline
  flex-row()
  justify-content space-between
  .fineName
    margin-left 30px
.view, .del, .editor, .path, .upShelves, .downShelves, .wechat
  color #1890ff
  cursor pointer
.view, .del, .editor, .path, .upShelves, .downShelves, .wechat
  margin-right 20px
.memberImg
  width 150px
  height 100px
.wechatImg
  width 150px
  height 150px
</style>
<style lang="stylus">
.wechatCode
  background rgba(0, 0, 0, 0)
  min-width 150px
  padding 0
  border none
  margin 0
</style>
